




































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import HazardouswastestorageDetail from "./hazardouswastestorage-detail.vue";
   
let ispartysrc= require("@/images/danghui.png");

class PageBHUserRequest extends PageRequest {
  Keyword: string;
  isrent: number; //nullable
  stime: Date;
  etime: Date;
  Vid:number;
}
 @Component({
        components:{HazardouswastestorageDetail}
    })

  
export default class Hazardouswastestorage extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageBHUserRequest = new PageBHUserRequest();
   

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
                   
    return this.$store.state.hazardouswastestorage.list;
  }
  get loading() {
    return this.$store.state.hazardouswastestorage.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("hazardouswastestorage/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("hazardouswastestorage/setPageSize", pagesize);
    this.getpage();
  }
  
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    

    await this.$store.dispatch({
      type: "hazardouswastestorage/getFinalDataAll",
      data: this.pagerequest,
    });
  }

  async  getbyid(id) {
   var ltdata=null;
     await    this.$store.dispatch({
      type: "hazardouswastestorage/getbyid",
       data:{id},
    }).then((data) => { 
       ltdata=data;
      }).catch((error) => { 
      })
   
       
     return ltdata;
  }
     
  get pageSize() {
    return this.$store.state.hazardouswastestorage.pageSize;
  }
  get totalCount() {
    return this.$store.state.hazardouswastestorage.totalCount;
  }
  get currentPage() {
    return this.$store.state.hazardouswastestorage.currentPage;
  }
   
 
  columns = [
       
     {
      
      title: this.L("绑定企业"),
      key: "corporatename",
     
    },
      
     {
      
      title: this.L("智能设备"),
      key: "hname",
      
    },
    {
      
      title: this.L("当前重量"),
      key: "currentweight",
      width: 100, 
    },
     {
      
      title: this.L("当前设备电量"),
      key: "currentbatterylevel",
       width: 200, 
    },
     {
      
      title: this.L("温度"),
      key: "temperature",
       width: 100, 
    },
     {
      
      title: this.L("湿度"),
      key: "humidity",
       width: 100, 
    },
     {
      title: this.L("更新时间"),
      key: "updatetime",
      render: (h: any, params: any) => {

        var time=""
        if(params.row.updatetime!=null){
          time= new Date(params.row.updatetime).toLocaleString();
        }	
        if(time=="1/1/1 00:00:00"){
          time="";
        }

        return h("span", time);
      },
      width: 180,
    },
     
     
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                     
                  var datastr= this.getbyid(params.row.id)
                  this.$store.commit("hazardouswastestorage/editbyid", datastr);
                  this.edit();
                },
              },
            },
            this.L("详细")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteDataConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "hazardouswastestorage/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    
    this.getpage();
    
    
  }

   

 //导出
   async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "hazardouswastestorage/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				
					lt.map((item) => { // 这里修改要下载的字段内容
					 
                     item.updatetime= new Date( item.updatetime).toLocaleString();
					  return item;
					});



                        
 

                 
    
					const filterVal = ['id', 'corporatename','hname','currentweight','currentbatterylevel','temperature','humidity','updatetime' ];// 取出要下载的表头字段
					const tHeader = ['ID','绑定企业','智能设备','当前重量','当前设备电量','温度','湿度','更新时间'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '危废存储');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}

			
}
